<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="11.885" height="11.983" viewBox="0 0 11.885 11.983">
		<g id="Group_21741" data-name="Group 21741" transform="translate(-554.537 -1206.556)">
			<g id="Group_20186" data-name="Group 20186" transform="translate(554.537 1206.556)">
				<g id="Group_8569" data-name="Group 8569">
					<g id="Group_8564" data-name="Group 8564">
						<path
							id="Path_1125"
							data-name="Path 1125"
							d="M567.008,1220.884a1.994,1.994,0,0,1-1.992-1.992,1.866,1.866,0,0,1,.631-1.433l1.358-1.358,1.358,1.358a1.868,1.868,0,0,1,.631,1.433A1.993,1.993,0,0,1,567.008,1220.884Zm0-3.828-.881.88a1.214,1.214,0,0,0-.433.957,1.313,1.313,0,1,0,2.627,0v0a1.209,1.209,0,0,0-.433-.957Z"
							transform="translate(-557.111 -1208.9)"
							fill="#515a70"
						/>
						<path
							id="Path_1126"
							data-name="Path 1126"
							d="M559.689,1218.635a.587.587,0,0,1-.293-.075l-4.566-2.636a.589.589,0,0,1-.215-.8l3.661-6.342,6.132,3.541a.524.524,0,0,1-.243.977,1.916,1.916,0,0,0-1.608.963l-2.359,4.087A.592.592,0,0,1,559.689,1218.635Zm-4.44-3.257,4.409,2.545,2.308-4a2.6,2.6,0,0,1,1.7-1.251l-5.146-2.971Z"
							transform="translate(-554.537 -1207.102)"
							fill="#515a70"
						/>
						<path
							id="Path_1127"
							data-name="Path 1127"
							d="M561.1,1212h-.679v-3.546a1.225,1.225,0,0,0-2.45,0v2.742h-.679v-2.742a1.9,1.9,0,0,1,3.805,0Z"
							transform="translate(-555.213 -1206.556)"
							fill="#515a70"
						/>
						<circle
							id="Ellipse_108"
							data-name="Ellipse 108"
							cx="0.59"
							cy="0.59"
							r="0.59"
							transform="translate(4.956 4.858)"
							fill="#515a70"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'FontColorSvg',
};
</script>

<style scoped lang="scss"></style>
